{
  "auth.eyebrow": "404 Estate",
  "auth.signIn.title": "Sign in to {company}",
  "auth.signIn.subtitle": "Your listings, leads and deals, in one calm place.",
  "auth.signIn.submit": "Sign in",
  "auth.signIn.submitting": "Signing in…",
  "auth.signIn.forgot": "Forgot password?",
  "auth.signIn.invalid": "That email and password don't match. Check them and try again.",
  "auth.signIn.tooMany": "Too many attempts. Wait a minute, then try again.",
  "auth.field.email": "Work email",
  "auth.field.password": "Password",
  "auth.field.newPassword": "New password",
  "auth.field.confirmPassword": "Confirm new password",
  "auth.showPassword": "Show password",
  "auth.hidePassword": "Hide password",
  "auth.validation.email": "Enter a valid email address.",
  "auth.validation.passwordRequired": "Enter your password.",
  "auth.validation.passwordMin": "Use at least 8 characters.",
  "auth.validation.passwordMatch": "The passwords don't match.",

  "auth.forgot.title": "Reset your password",
  "auth.forgot.subtitle": "Enter your work email and we'll send you a 6-digit code.",
  "auth.forgot.submit": "Send code",
  "auth.forgot.submitting": "Sending…",
  "auth.forgot.backToSignIn": "Back to sign in",

  "auth.verify.title": "Check your email",
  "auth.verify.subtitle": "We sent a 6-digit code to {email}.",
  "auth.verify.codeLabel": "Verification code",
  "auth.verify.digit": "Digit {position} of 6",
  "auth.verify.submit": "Verify code",
  "auth.verify.submitting": "Verifying…",
  "auth.verify.expiresIn": "Code expires in {time}",
  "auth.verify.expired": "This code has expired. Request a new one.",
  "auth.verify.resend": "Send a new code",
  "auth.verify.resendIn": "Send a new code in {seconds}s",
  "auth.verify.resent": "A new code is on its way.",
  "auth.verify.invalid": "That code isn't right, or it has expired.",
  "auth.verify.useDifferentEmail": "Use a different email",

  "auth.reset.title": "Choose a new password",
  "auth.reset.subtitle": "Use at least 8 characters. A longer passphrase is stronger.",
  "auth.reset.submit": "Update password",
  "auth.reset.submitting": "Updating…",
  "auth.reset.done": "Password updated. Sign in with your new password.",
  "auth.reset.missing": "Your reset session has ended. Start again.",

  "auth.strength.weak": "Weak",
  "auth.strength.fair": "Fair",
  "auth.strength.good": "Good",
  "auth.strength.strong": "Strong",

  "auth.art.kicker": "Real-estate CRM",
  "auth.art.headline": "Close more deals with less chasing.",
  "auth.art.point1": "Every unit, lead and deal in one place",
  "auth.art.point2": "Offers your clients actually read",
  "auth.art.point3": "Your team's day, at a glance",
  "auth.art.card.won": "Moved to Closed-Won",
  "auth.art.card.wonMeta": "Pipeline · just now",
  "auth.art.card.offer": "Offer PDF ready",
  "auth.art.card.offerMeta": "Branded, one page, sent",
  "auth.art.card.viewing": "Viewing booked",
  "auth.art.card.viewingMeta": "Tomorrow · 4:30 PM",
  "auth.art.crafted": "Crafted by 404 Creative"
}
